module.exports = "pegasus_template/assets/time-card.png";